let _counter = 0;

export const uid = (prefix = "id") => `${prefix}-${Date.now()}-${++_counter}`;

export const stepId = () => uid("step");
export const itemId = () => uid("item");

/**
 * Immutably move an item in an array from one index to another
 */
export function arrayMove<T>(arr: T[], from: number, to: number): T[] {
  const result = [...arr];
  const [moved] = result.splice(from, 1);
  result.splice(to, 0, moved);
  return result;
}

/**
 * Format price in euros
 */
export function formatPrice(price: number): string {
  return `€${price.toLocaleString()}`;
}
